import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useListItemClassNames } from './hooks/useListItemClassNames';
import { useListItem } from './hooks/useListItem';
import { ListItemRoot, PrimaryListItem, SecondaryListItem, ActionsContainer, PrimaryIconContainer, PrimaryLeadSubtitle, PrimaryListItemContainer } from './style';
import { LIST_ITEM_CLASS_PREFIX } from './contants';
import { useComponentTheme } from '../../../utils/hooks';
import { PrimaryIconWrapper } from '../PrimaryIconWrapper/PrimaryIconWrapper';
export var ListItem = forwardRef(function ListItem(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(LIST_ITEM_CLASS_PREFIX);
  var classNames = useListItemClassNames(LIST_ITEM_CLASS_PREFIX, className);

  var _useListItem = useListItem(props, ref),
      rootProps = _useListItem.rootProps,
      primaryListProps = _useListItem.primaryListProps,
      primaryLeadSubtitle = _useListItem.primaryLeadSubtitle,
      secondaryListProps = _useListItem.secondaryListProps,
      renderSubtitle = _useListItem.renderSubtitle,
      renderLead = _useListItem.renderLead,
      enableSecondaryItem = _useListItem.enableSecondaryItem,
      children = _useListItem.children,
      secondaryItemText = _useListItem.secondaryItemText,
      actions = _useListItem.actions,
      lead = _useListItem.lead,
      subtitle = _useListItem.subtitle,
      primaryIcon = _useListItem.primaryIcon,
      Tag = _useListItem.Tag,
      tagProps = _useListItem.tagProps,
      primaryIconWrapper = _useListItem.primaryIconWrapper,
      primaryIconWrapperProps = _useListItem.primaryIconWrapperProps;

  return React.createElement(ListItemRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps, tagProps), React.createElement(PrimaryListItem, Object.assign({}, primaryListProps, {
      theme: theme,
      className: classNames.PrimaryListItem
    }), primaryIcon && React.createElement(PrimaryIconContainer, {
      theme: theme,
      className: classNames.primaryIconContainer
    }, !primaryIconWrapper ? primaryIcon : React.createElement(PrimaryIconWrapper, Object.assign({}, primaryIconWrapperProps, {
      theme: theme,
      className: classNames.PrimaryIconWrapper
    }), primaryIcon)), React.createElement(PrimaryListItemContainer, {
      theme: theme,
      className: classNames.PrimaryListItemContainer
    }, renderLead && React.createElement(PrimaryLeadSubtitle, Object.assign({}, primaryLeadSubtitle, {
      theme: theme,
      className: classNames.PrimaryLeadSubtitle
    }), lead), children, renderSubtitle && React.createElement(PrimaryLeadSubtitle, Object.assign({}, primaryLeadSubtitle, {
      theme: theme,
      className: classNames.PrimaryLeadSubtitle
    }), subtitle))), !!enableSecondaryItem && React.createElement(SecondaryListItem, Object.assign({}, secondaryListProps, {
      theme: theme,
      className: classNames.SecondaryListItem
    }), secondaryItemText, !!actions && React.createElement(ActionsContainer, {
      theme: theme,
      className: classNames.ActionsContainer
    }, actions)));
  });
});
ListItem.defaultProps = {
  disabled: false,
  size: 'medium',
  divider: false,
  enableSecondaryItem: true,
  enableLink: false,
  primaryIconWrapper: false
};